export const parseCurrency = (price: string | number | null, code: string): string | null => {
    return price ? parseFloat(<string>price).toLocaleString('ru-RU', {
        style: 'currency',
        currency: code ?? 'RUB',
    }).replace('KZT', '₸') : null;
}